import { render, staticRenderFns } from "./editToolbar.vue?vue&type=template&id=2050ec83&scoped=true&"
import script from "./editToolbar.vue?vue&type=script&lang=js&"
export * from "./editToolbar.vue?vue&type=script&lang=js&"
import style0 from "./editToolbar.vue?vue&type=style&index=0&id=2050ec83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2050ec83",
  null
  
)

export default component.exports